import './styles/Footer.css'

export const Footer = () => {
  return <footer>© The NOW Database {new Date().getFullYear()}</footer>
}
